import _ from "lodash";
import { useContext, useEffect, useMemo, useState } from "react";
import { AppContext } from "../../AppContext";
import { PosContext } from "../../shared/PosContext";
import { useMoveOrderItems } from "../../shared/hooks/useOrdersData";
import { useTableOrders } from "../../shared/hooks/useTableOrdersData";
import OrdersListWidget from "../AddPaymentWidget/OrdersListWidget";
import SmallTablePlaceholder from "../SmallTablePlaceholder";
import { useStyles } from "./styles";
import { enqueueSnackbar } from "notistack";

const MoveOrdersWidget = ({ onConfirm, sourceTable, distTable, onClose }) => {
    const classes = useStyles();

    const { menuItems } = useContext(AppContext);

    const { refetchTablesData } = useContext(PosContext);

    const menuItemList = useMemo(() => {
        return menuItems || [];
    }, [menuItems]);

    const [orderNames, setOrderNames] = useState([]);
    const [displayOrders, setDisplayOrders] = useState([]);
    const [moveTableSelectedOrders, setMoveTableSelectedOrders] = useState([]);

    const { data: tableOrdersInternal } = useTableOrders(
        sourceTable?.name || null,
        "for_move"
    );

    const [tableItems, setTableItems] = useState([]);
    useEffect(() => {
        if (sourceTable && orderNames) {
            let totalOrders = [];

            const _tableItems = [];
            Object.values(sourceTable.orders)
                .filter((i) => orderNames.includes(i.name))
                .map((order) => {
                    let orderItems = [];
                    const name = order.name;
                    let orderElement = { title: name, items: orderItems };
                    order.entry_items.map((item) => {
                        if (
                            menuItemList.find(
                                (i) => i.item_code === item.item_code
                            )
                        ) {
                            _tableItems.push(item);
                        }
                        let itemElement = {
                            ...item,
                            title: item.item_code,
                            label: item.item_name,
                            price: item.rate,
                        };
                        orderItems.push(itemElement);
                    });
                    totalOrders.push(orderElement);
                });

            setTableItems(_tableItems);
            setDisplayOrders(totalOrders);
        }
    }, [sourceTable, orderNames, menuItemList]);

    useMemo(() => {
        if (!tableOrdersInternal) {
            return;
        }

        let orderNames = [];
        tableOrdersInternal.forEach((item) => {
            orderNames.push(item.name);
        });

        setOrderNames(orderNames);
    }, [tableOrdersInternal]);

    const tables = [
        {
            name: sourceTable.tableDescription,
            floor: "1",
            actions: [],
        },
        {
            name: distTable.tableDescription,
            floor: "1",
            actions: [],
        },
    ];


    const moveItemsMutation = useMoveOrderItems();

    const [moveLoading, setMoveLoading] = useState(false);
    const handleMoveTables = (modfiedItems) => {
        const clientId = modfiedItems.client;
        if (modfiedItems && modfiedItems.items) {
            if (Object.entries(modfiedItems.items).length === 0) {
                const totalModifiedPayload = {
                    items: {},
                };

                tableItems.forEach((itemPayload, identifier) => {
                    let anotherMap = {
                        identifier: itemPayload.identifier,
                        name: itemPayload.name,
                        qty: itemPayload.qty,
                        addons: itemPayload.addons,
                        notes: itemPayload.notes,
                    };
                    totalModifiedPayload.items[itemPayload.identifier] =
                        anotherMap;
                });

                totalModifiedPayload.client = "obj_3a5d-bf-457-825-0c237";
                modfiedItems = totalModifiedPayload;
            } else {
                console.log("The object is not empty.");
            }
        }

        const _newItems = {};

        const _addonsItems = [];

        Object.keys(modfiedItems.items).map((key) => {
            const newItem = { ...modfiedItems.items[key] };

            let _item = null;

            Object.values(sourceTable.orders)
                .filter((i) => orderNames.includes(i.name))
                .map((order) => {
                    _item =
                        order.entry_items.find(
                            (entryItem) => entryItem.name === newItem.name
                        ) || _item;
                });

            newItem.notes = _item.notes;
            newItem.addons = _item.addons;
            // newItem.qty = _item.qty;
            let _addon = null;

            let _addons = [];

            JSON.parse(newItem.addons).map((addon) => {
                Object.values(sourceTable.orders)
                    .filter((i) => orderNames.includes(i.name))
                    .map((order) => {
                        _addon =
                            order.entry_items.find(
                                (entryItem) => entryItem.item_code === addon
                            ) || _addon;
                    });
                if (_addon) {
                    _addons.push({ ..._addon, qty: newItem.qty });
                }
            });

            // newItem.addons = _addons;
            _addonsItems.push(..._addons);
            // newItem.identifier = key;
            _newItems[key] = newItem;
        });

        const addonItems = {};
        _addonsItems.map((item) => {
            addonItems[item.identifier] = item;
        });

        const itemsPayload = { ..._newItems, ...addonItems };
        if (distTable?.name && Object.keys(itemsPayload).length > 0) {
            setMoveLoading(true);
            moveItemsMutation.mutate(
                {
                    items: itemsPayload,
                    destinationTable: distTable.name,
                    client: clientId,
                    orderId: orderNames[0],
                },
                {
                    onSuccess: (res) => {
                        refetchTablesData();
                        onClose();
                    },
                    onSettled: () => {
                        setMoveLoading(false);
                    },
                }
            );
        } else {
            setMoveLoading(false);
            if (distTable?.name) {
                enqueueSnackbar("No items to move", {
                    variant: "error",
                });
            } else {
                enqueueSnackbar("Please select a destination table", {
                    variant: "error",
                });
            }
        }
    };

    return (
        <div className={classes.MoveOrdersWidget}>
            <div className={classes.SmallTablePlaceholderWrapper}>
                <SmallTablePlaceholder tables={tables} />
            </div>
            <div className={classes.PayOrdersWidget__Title}>
                Select orders to move
            </div>
            <OrdersListWidget
                entryItems={tableItems}
                loading={moveLoading}
                handleNext={(totalModifiedPayload) => {
                    handleMoveTables(totalModifiedPayload);
                }}
                backCallback={() => {}}
                table={sourceTable}
                distTable={distTable}
                moveLoading={moveLoading}
            />
        </div>
    );
};

export default MoveOrdersWidget;
